import {IMeasurement, IMeasurementUnit} from '../measurement';
import {ExerciseTimeSinceStartEnum, PhysicalActivityLevelEnum} from '../../enums/record';
import {GenderEnum} from '../user';
import {PatientGoalControlTypeEnum, PatientGoalNumberTypeEnum, PatientGoalTypeEnum} from '../../enums/patient-goal';
import {AnyObject} from '../../interfaces/utils';

// tslint:disable-next-line:no-namespace
export namespace SPHERE {

  export interface ISphere {
    user: ISphereUser;
    feeding?: ISphereFeeding;
    physicalActivity: ISpherePhysicalActivity;
    indicators: ISphereIndicators; // TODO: Pending
    diagnosis: ISphereDiagnosis;
    laboratory: ISphereLaboratory;
    medicalPersonal: ISphereMedicalPersonal;
    medicalInheritedFamily: ISphereMedicalInheritedFamily;
    nutritionalHistory: ISphereNutritionalHistory;
    measurements: ISpherePatientMeasurement[];
    medicines: ISphereMedicine;
    patientGoals: ISpherePatientGoals[];
    score: number;
    totalPercentage: number;
  }

  export interface ISphereUser {
    name: string;
    lastname: string;
    gender: GenderEnum;
    birthday: Date;
  }

  export interface ISpherePatientMeasurement {
    _id?: string;
    measurementName?: string;
    measurementNameEs?: string;
    measurementIconName?: string;
    measurementCategory?: string;
    value: number;
    date?: Date;
    automaticallyGenerated: boolean;
    measureUnitSymbolEs?: string;
  }

  export interface ISphereMedicalPersonal {
    diseaseCategories: ISphereDiseaseCategory[];
    surgeries?: string;
  }

  export interface ISphereMedicalInheritedFamily {
    diseaseCategories: ISphereDiseaseCategory[];
    updatedAt: string;
    saved: boolean;
    score: number;
    percentage: number;
    totalPercentage: number;
  }

  export interface ISphereDiseaseCategory {
    name: string;
    icon: string;
    diseases: ISphereDisease[];
  }

  export interface ISphereDisease {
    name: string;
    identifier: string;
    familyMembers?: { relation: string, quantity: number }[];
  }

  // TODO: Pending properties
  export interface ISphereIndicators {
    drinkAlcohol: boolean;
    drinkAlcoholFrequency: number;
    drinkCoffee: boolean;
    drinkCoffeeFrequency: number;
    smoke: boolean;
    smokeFrequency: number;
    saved: boolean;
    updatedAt: string;
    score: number;
    percentage: number;
    totalPercentage: number;
  }

  export interface ISpherePhysicalActivity {
    physicalLevelActivity: PhysicalActivityLevelEnum;
    exercisePerWeek: number;
    exerciseIntensity: number;
    exerciseTimeSinceStart: ExerciseTimeSinceStartEnum;
    sedentary: {
      name: SphereSedentaryLevelEnum;
      value: number;
    };
    updatedAt: string;
    saved: boolean;
    score: number;
    percentage: number;
    totalPercentage: number;
  }

  export enum SphereSedentaryLevelEnum {
    LIGHT = 'LIGHT',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
  }

  export interface ISphereNutritionalHistory {
    // foodLikes: string;
    // foodDislikes: string;
    foodLikes: IIngredient[];
    foodDislikes: IIngredient[];
    feedingPreference: string;
    allergies: IIngredient[];
  }

  export interface ISphereFeeding {
    mealPlan?: ISphereMealPlan;
    // Experience properties
    likedPlan?: number;
    easyOrDifficultFollowThPlan?: number;
    feelingOfImprovementInWellBeing?: number;
    saved: boolean;
    experienceRecordIsVisible: boolean;
    updatedAt: string;
    score: number;
    percentage: number;
    totalPercentage: number;
  }

  export interface ISphereMealPlan {
    name: string;
    macronutrients: {
      carbohydrate_g: number; // Carbohidratos
      dietaryFiber_g: number; // Fibra
      protein_g: number; // Proteínas
      netWeight: number; // Caloría
      totalFat_g: number; // Grasas
    };
  }

  export interface ISphereDiagnosis {
    cardiovascularRisk?: any;
    // TODO: Pendiente hasta nuevo aviso
    // BMIClassification:
  }

  // export enum BMIClassificationEnum {}

  export interface ISphereLaboratory {
    biochemicals: ISphereBiochemical[];
  }

  export interface ISphereBiochemical {
    name: string;
    nameEs: string;
    value: number;
    measureUnitSymbolEs: string;
    range: {
      min: number;
      max: number;
    };
  }

  export interface ISphereMedicine {
    medicines: string;
  }

  export interface ISpherePatientGoals {
    goalType: PatientGoalNumberTypeEnum;
    initial: number;
    actual: number;
    goalStart: number;
    goalEnd: number;
    goalDate: Date;
    percentage: number;
    measurement: Partial<IMeasurement>;
    measureUnit: Partial<IMeasurementUnit>;
    metadata?: {
      userValues: AnyObject;
      controlType: PatientGoalControlTypeEnum;
      type: PatientGoalTypeEnum;
      limits?: {start: number, end: number};
    };
  }

  export interface IIngredient {
    ingredientName: string;
    ingredientId: string;

    [key: string]: any;
  }
}


